module.exports = __webpack_public_path__ + "img/blog9.8309f2a4.png";